/* eslint-disable @typescript-eslint/no-unused-vars */
import {useContext, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import parseJWT from 'utils/parseToken'
import {useForm} from 'react-hook-form'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
// import {ILogin} from 'models/Auth'
import {TextField} from 'helpers/ui-components/form/TextField'
import {userService} from 'utils/api/auth/authService'
import {IFormField, IReduxStore} from 'models/Common'
import {persistToken} from 'utils/helper'
import Spinner from 'layout/common/Spinner'
import {setTokens} from 'redux/slice/authSlice'
import {
 ACCESS_TOKEN_KEY,
 REFRESH_TOKEN_KEY,
} from 'constants/common'
import {AuthContext} from 'context/AuthProvider'
import {fetchUserDetails} from 'utils/api/auth/userService'
import {IUserDetails} from 'models/Auth'
import {
 fetchUserConfig,
 fetchUserMenu,
} from 'utils/api/cms/fetchUserConfig'
import {toast} from 'react-toastify'
import {consumePostLoginRedirect} from 'helpers/authRedirect'

// type Props = {}

const OtpPage = () => {
 const {t} = useTranslation()
 const navigate = useNavigate()
 const dispatch = useDispatch()
 const authReducer = useSelector(
  (state: IReduxStore) => state.authReducer
 )

 const {userData} = useContext(AuthContext)
 const [loader, setLoader] = useState(false)
 const [authSuccess, setAuthSuccess] = useState(false)
 const otpForm = {
  otp: '',
 }
 const length = 6
 const [mobileNo, setMobileNo] = useState('')
 const [otp] = useState<string[]>(Array(length).fill(''))

 const {
  register,
  setFocus,
  handleSubmit,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...otpForm, otp},
 })

 const handleChange = (input: string, index: number) => {
  if (input && index < length - 1) {
   setFocus(`otp.${index + 1}`)
  }

  if (input.length === 0 && index > 0) {
   setFocus(`otp.${index - 1}`)
  }
 }

 async function submitOTPFormData(formData: IFormField) {
  const otp = formData?.otp
  if (Array.isArray(otp)) {
   setLoader(true)
   const res = await userService.login({
    user_id: authReducer.userId,
    otp: otp.join('').toString(),
    client_id: 'businessapp',
   })
   if (res) {
    //  setUserResponse(res)
    const {access_token, refresh_token} = res
    const accessTokenData = parseJWT(access_token)
    //  const refreshTokenData = parseJWT(refresh_token)
    dispatch(setTokens({results: res}))
    //  dispatch(setAuthData(res))
    persistToken(
     ACCESS_TOKEN_KEY,
     access_token,
     accessTokenData.exp
    )
    persistToken(
     REFRESH_TOKEN_KEY,
     refresh_token,
     30 * 86400
    )
    const userDetails: IUserDetails | null =
     await fetchUserDetails()
    if (userDetails) {
     let userMenu: IFormField = {}
     let userConfig: IFormField = {}
     if (userDetails?.user_category_key) {
      userMenu = await fetchUserMenu(
       userDetails.user_category_key,
       userData?.selectedLanguage
      )
      userConfig = await fetchUserConfig(
       userDetails.user_category_key
      )
     }

     localStorage.setItem(
      'user',
      JSON.stringify({
       menu: userMenu,
       ...userConfig,
       categoryId: userDetails?.category,
       email: userDetails?.email,
       mobileNumber: userDetails.phone_number,
       name: userDetails?.full_name,
       geoMapping: userDetails?.geo_mapping,
       status: userDetails?.status,
       userCategory: userDetails?.user_category,
       selectedLanguage: userData?.selectedLanguage ?? 'en',
       userCategoryId: userDetails?.user_category_id,
       userId: userDetails.id,
       lastLogin: userDetails?.last_login,
       organisation: userDetails?.organisation,
       organisationId: userDetails?.organisationId,
       userCategoryKey: userDetails?.user_category_key,
       profile: userDetails?.profile,
       auth: {
        accessExpiresIn: accessTokenData.exp,
        accessToken: access_token,
        refreshExpiresIn: 30 * 86400,
        refreshToken: refresh_token,
       },
      })
     )
    }
    setAuthSuccess(true)
   }
   setLoader(false)
  }
 }

 const resendOTP = async () => {
  const res = await userService.getOTP({
   phone_number: authReducer.mobileNo,
  })
  if (res) {
   toast.success(t('otpPage.msgSent'))
  }
 }

 useEffect(() => {
  if (authSuccess) {
   const storedUser = JSON.parse(
    localStorage.getItem('user') ?? '{}'
   )
   const redirectPath =
    consumePostLoginRedirect(storedUser?.routes) ??
    '/home-page'
   window.location.href = redirectPath
  }
 }, [authSuccess])

 useEffect(() => {
  if (authReducer) {
   if (authReducer.mobileNo) {
    setMobileNo(authReducer.mobileNo.toString())
   }
  }
 }, [authReducer])

 return (
  <>
   {loader && <Spinner />}
   <div className='container bg-white'>
    <div className='bg-white flex items-center justify-center min-h-full sm:pt-3 md:pt-14'>
     <div className='relative sm:w-full md:w-[360px] '>
      <div className='text-center'>
       <span className='text-[#33393D] text-2xl font-bold'>
        {t('otpPage.title')}
       </span>
      </div>
      <div className='my-8 text-left text-lg font-medium'>
       <span className='text-[##666666]'>
        {t('otpPage.msgSent')}{' '}
        {`"******${mobileNo.substr(mobileNo.length - 4)}"`}
       </span>
      </div>
      <form
       method='POST'
       action=''
       onSubmit={handleSubmit(submitOTPFormData)}
      >
       <div className='relative w-full my-8'>
        <div className='relative w-full'>
         <div className={`grid grid-cols-${length} gap-5`}>
          {Array.from({length}, (_, index) => (
           <TextField
            key={index}
            type='text'
            className='relative text-[#171B1F] !text-2xl !px-0 !font-medium block items-center'
            wrapperClassName='relative w-full'
            inputWrapperClassName='!w-[50px] !h-[64px] text-center flex items-center'
            required={false}
            id={`otp.${index}`}
            name={`otp.${index}`}
            placeholder={'_'}
            minLength={1}
            maxLength={1}
            register={register(`otp.${index}`, {
             validate: {
              regex: (v: string) => {
               if (v !== '' && !v?.match('^[0-9]{1}$'))
                return ``
              },
              required: (v: string) => {
               if (v === '') return ``
              },
             },
             onChange: (e: {target: {value: string}}) =>
              handleChange(e.target.value, index),
            })}
            errors={errors}
           />
          ))}
         </div>
         {errors && Object.keys(errors).length !== 0 && (
          <p className='error-msg error-cls'>
           {t('otpPage.otpErrorMsg')}
          </p>
         )}
        </div>
       </div>
       <div className='md:flex items-center justify-center w-full mt-8'>
        <Button
         disabled={
          errors && Object.keys(errors).length !== 0
         }
         type='submit'
         color='blue'
         className='text-center w-full py-[9px] px-[24px] bg-[#4E83E4] 
                  !rounded-lg !text-base text-white font-semibold'
        >
         {t('otpPage.continue')}
        </Button>
       </div>
      </form>
      <div className='my-8 text-center text-lg font-normal'>
       <span className='text-[#808080]'>
        {t('otpPage.didNotReceiveCode')}?{' '}
       </span>
       <button
        className='text-[#4E83E4]'
        onClick={resendOTP}
       >
        {t('otpPage.resend')}
       </button>
      </div>
     </div>
    </div>
   </div>
  </>
 )
}

export default function OtpPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 return (
  <>
   {/* <PageTitle
        breadcrumbs={[{title: 'sdf', path: 'login', isActive: false}]}
        description='Welcome'
      >
        Welcome Page
      </PageTitle> */}
   <OtpPage />
  </>
 )
}
